import { RequestExplorerActionTypes, RequestExplorerContext } from 'contexts/RequestExplorer';
import type { FC } from 'react';
import { useContext } from 'react';
import type { IContainerChildrenProps } from 'utils';
import { EditGrid } from '../../../EditGrid';

interface RequestExplorerProps extends IContainerChildrenProps {
  locked?: boolean;
  // params: Record<string, string | number | undefined>;
  url: string;
}
const RequestParams: FC<RequestExplorerProps> = ({ locked, url }) => {
  const ctx = useContext(RequestExplorerContext);
  if (!ctx) {
    // eslint-disable-next-line no-console
    console.error('RequestExplorerContextProvider required');

    return <>RequestExplorerContextProvider required</>;
  }

  return (
    <EditGrid
      columns={{
        key: {
          key: 'key',
          label: 'Key',
          placeholder: 'Key',
          width: '20fr'
        },
        value: {
          key: 'value',
          label: 'Value',
          placeholder: 'Value',
          width: '20fr'
        }
      }}
      value={ctx.state.params}
      checked="use"
      onToggleChecked={(index, checked) => {
        ctx?.dispatch({
          type: RequestExplorerActionTypes.TOGGLE_PARAM,
          payload: { index, active: checked }
        });
      }}
      onChange={(index, column, value) => {
        const payload = {
          index,
          key: undefined,
          value: undefined
        };
        payload[column] = value;
        ctx?.dispatch({
          type: RequestExplorerActionTypes.UPDATE_PARAM,
          payload
        });
      }}
      onDeleteRow={index => {
        ctx?.dispatch({
          type: RequestExplorerActionTypes.DELETE_PARAM,
          payload: { index }
        });
      }}
    />
  );
};

export default RequestParams;
